import React, {Component} from 'react'
import {Col, Form, Input, Row, Select} from 'antd'
import CountrySelect from '../../../../../elements/Select/Country'
import {strVal} from '../../../../../modules/Utils'
import InfoText from '../../../../../elements/InfoText'
import {compose} from 'recompose'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'

const FormItem = Form.Item
const {Option} = Select

class Communication extends Component {
  render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }

    const {getFieldDecorator} = this.props.form
    const {contract, type} = this.props
    return (
      <Form layout="horizontal">
        <Row style={{paddingBottom: '10px', paddingTop: '10px'}}>
          <h3 style={{color: '#1890ff'}}>NOTICE ADDRESS</h3>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Country" {...formItemLayout}>
              {getFieldDecorator('employee.address.country', {
                initialValue: strVal(contract, 'employee.address.country'),
                rules: [
                  {
                    required: true,
                    message: "Country can't be empty ",
                  },
                ],
              })(<CountrySelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Postcode" {...formItemLayout}>
              {getFieldDecorator('employee.address.postcode', {
                initialValue: strVal(contract, 'employee.address.postcode'),
                rules: [
                  {
                    required: true,
                    message: "Postcode can't be empty ",
                  },
                ],
              })(<Input placeholder="Postcode" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem label="Street" {...formItemLayout}>
              {getFieldDecorator('employee.address.street', {
                initialValue: strVal(contract, 'employee.address.street'),
                rules: [
                  {
                    required: true,
                    message: "Street can't be empty ",
                  },
                ],
              })(<Input placeholder="Street" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem label="Building" {...formItemLayout}>
              {getFieldDecorator('employee.address.address', {
                initialValue: strVal(contract, 'employee.address.address'),
              })(<Input placeholder="Building" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Town / Suburb" {...formItemLayout}>
              {getFieldDecorator('employee.address.city', {
                initialValue: strVal(contract, 'employee.address.city'),
                rules: [
                  {
                    required: true,
                    message: "Town / Suburb can't be empty ",
                  },
                ],
              })(<Input placeholder="Town / Suburb" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="City / State" {...formItemLayout}>
              {getFieldDecorator('employee.address.state', {
                initialValue: strVal(contract, 'employee.address.state'),
                rules: [
                  {
                    required: true,
                    message: '"City / State can\'t be empty ',
                  },
                ],
              })(<Input placeholder="City / State" />)}
            </FormItem>
          </Col>
        </Row>
        <Row style={{paddingBottom: '10px', paddingTop: '10px'}}>
          <h3 style={{color: '#1890ff'}}>CONTACT DETAILS</h3>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Phone" {...formItemLayout}>
              {getFieldDecorator('employee.phone.label', {
                initialValue: strVal(contract, 'employee.phone.label'),
                rules: [
                  {
                    required: true,
                    message: "Phone can't be empty ",
                  },
                ],
              })(<Input placeholder="Phone" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Fax" {...formItemLayout}>
              {getFieldDecorator('employee.fax.label', {
                initialValue: strVal(contract, 'employee.fax.label'),
              })(<Input placeholder="Fax" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Mobile" {...formItemLayout}>
              {getFieldDecorator('employee.mobile.label', {
                initialValue: strVal(contract, 'employee.mobile.label'),
              })(<Input placeholder="Mobile" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Email" {...formItemLayout}>
              {getFieldDecorator('employee.email.label', {
                initialValue: strVal(contract, 'employee.email.label'),
                rules: [
                  {
                    required: true,
                    message: "Email can't be empty ",
                  },
                ],
              })(<Input placeholder="Email" />)}
            </FormItem>
          </Col>
        </Row>
        {type !== 'update' && (
          <InfoText
            text={
              'Contact details are pre-loaded from employee default contacts'
            }
          />
        )}
      </Form>
    )
  }
}

export default compose(Form.create(), withLoadingSection)(Communication)
